import { render, staticRenderFns } from "./ideaHandle.vue?vue&type=template&id=48f56bba&"
import script from "./ideaHandle.vue?vue&type=script&lang=js&"
export * from "./ideaHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports